import {
  DTOCreateDocumentationGroupInput,
  DTOCreateDocumentationPageInputV2,
  DTOCreateDocumentationTabInput,
  DTOElementActionInput,
  DTOElementActionOutput,
  DTOElementPropertyValueUpsertPaylod,
  DTOFigmaNodeRenderIdInput,
  DTOFigmaNodeRenderInput,
  DTOMoveDocumentationGroupInput,
  DTOUpdateDocumentationGroupInput,
  DTOUpdateDocumentationPageDocumentInputV2,
  DTOUpdateDocumentationPageInputV2,
} from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class ElementsActionEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  async createDocPage(dsId: string, vId: string, input: DTOCreateDocumentationPageInputV2) {
    return this.action(dsId, vId, { type: "DocumentationPageCreate", input });
  }

  async createDocGroup(dsId: string, vId: string, input: DTOCreateDocumentationGroupInput) {
    return this.action(dsId, vId, { type: "DocumentationGroupCreate", input });
  }

  async moveDocGroup(dsId: string, vId: string, input: DTOMoveDocumentationGroupInput) {
    return this.action(dsId, vId, { type: "DocumentationGroupMove", input });
  }

  async updateDocPage(dsId: string, vId: string, input: DTOUpdateDocumentationPageInputV2) {
    return this.action(dsId, vId, { type: "DocumentationPageUpdate", input });
  }

  async updateDocPageDocument(dsId: string, vId: string, input: DTOUpdateDocumentationPageDocumentInputV2) {
    return this.action(dsId, vId, { type: "DocumentationPageUpdateDocument", input });
  }

  async updateDocGroup(dsId: string, vId: string, input: DTOUpdateDocumentationGroupInput) {
    return this.action(dsId, vId, { type: "DocumentationGroupUpdate", input });
  }

  async createDocTab(dsId: string, vId: string, input: DTOCreateDocumentationTabInput) {
    return this.action(dsId, vId, { type: "DocumentationTabCreate", input });
  }

  async renderNodes(dsId: string, vId: string, input: DTOFigmaNodeRenderIdInput[]) {
    return this.action(dsId, vId, { type: "FigmaNodeRender", input });
  }

  async renderNodesAsync(dsId: string, vId: string, nodes: DTOFigmaNodeRenderInput[]) {
    return this.action(dsId, vId, { type: "FigmaNodeRenderAsync", nodes });
  }

  async bulkEditPropertyValues(dsId: string, vId: string, values: DTOElementPropertyValueUpsertPaylod[]) {
    return this.action(dsId, vId, { type: "ElementPropertyValuesEdit", values });
  }

  private async action(dsId: string, vId: string, input: DTOElementActionInput) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/elements-action`,
      DTOElementActionOutput,
      {
        body: input,
        method: "POST",
      }
    );
  }
}
